"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translations = void 0;
const houseType_1 = require("./houseType");
const duty_1 = require("./duty");
const solution_1 = require("./solution");
const topic_1 = require("./topic");
const product_1 = require("./product");
const job_1 = require("./job");
const deal_1 = require("./deal");
exports.translations = {
    houseTypes: houseType_1.HOUSE_TYPE_CATEGORIES_NL,
    solutions: solution_1.SOLUTIONS_NL,
    solutionDomains: solution_1.SOLUTION_DOMAINS_NL,
    topics: topic_1.TOPICS_NL,
    intakeTopics: topic_1.INTAKE_TOPICS_NL,
    duties: duty_1.DUTIES_NL,
    productCategories: product_1.PRODUCT_CATEGORIES_NL,
    jobTypes: job_1.JOB_TYPES_NL,
    dealStatus: deal_1.DEAL_STATUS_NL,
};
